export default import.meta.ROLLDOWN_FILE_URL_PkxF29z2t0BRBBUgt983$A